






























import { Faction, finalScorings, FinalTile, Phase, Player } from "@gaia-project/engine";
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { MapMode, MapModeType } from "../data/actions";
import { factionName } from "../data/factions";
import Token from "./Token.vue";

@Component<FinalScoringTile>({
  computed: {
    tooltip() {
      const tile = this.tile;
      const players = this.players;

      return players
        .map((pl) => {
          const name = pl.faction === "automa" ? "Automa" : factionName(pl.faction);
          const points = this.progress(pl);
          return `- ${name}: ${points}`;
        })
        .join("\n");
    },

    highlighted() {
      return this.$store.state.data.phase === Phase.EndGame;
    },
  },

  components: {
    Token,
  },
})
export default class FinalScoringTile extends Vue {
  @Prop()
  index: number;

  progress(player: Player) {
    return (player.faction as Faction | "automa") === "automa"
      ? finalScorings[this.tile].neutralPlayer
      : player.progress(this.tile);
  }

  get tile(): FinalTile {
    return this.$store.state.data.tiles.scorings.final[this.index];
  }

  get mapModeType(): { type: MapModeType; player: Player }[] {
    const m = (type: MapModeType) =>
      this.players.filter((p) => p.faction != "automa").map((player) => ({ type, player }));
    switch (this.tile) {
      case FinalTile.Sector:
        return m(MapModeType.sectors);
      case FinalTile.StructureFed:
      case FinalTile.Satellite:
        return m(MapModeType.federations);
    }
    return [];
  }

  toggleMapMode(mode: MapModeType, player: Player) {
    this.$store.commit("toggleMapMode", { type: mode, player: player.player } as MapMode);
  }

  get content() {
    return this.tile;
  }

  get players() {
    const pls = this.$store.state.data.players.filter((player) => !!player && player.faction);

    if (this.$store.state.data.players.length === 2) {
      pls.push({ faction: "automa" });
    }

    return pls;
  }

  tokenX(index: number) {
    return (index % 2) * 30 + 23;
  }

  tokenY(index: number) {
    return 25 + (index > 1 ? 19 : 0);
  }
}
